import type { MapLegendEntry } from "./types";

interface MapLegendProps {
    entries: MapLegendEntry[];
}

/** Static colour key for the map. Reads the same palette the engine
 *  uses for markers (RISK_COLOR), so any palette tweak stays in sync. */
export function MapLegend({ entries }: MapLegendProps) {
    return (
        <div
            className="border-secondary bg-primary flex flex-wrap items-center gap-x-5 gap-y-2 rounded-md border px-4 py-3"
            role="list"
            aria-label="Risk level legend"
        >
            {entries.map((entry) => (
                <div key={entry.level} role="listitem" className="flex items-center gap-2">
                    <span aria-hidden="true" className="size-3 shrink-0 rounded-full" style={{ backgroundColor: entry.color }} />
                    <span className="text-secondary text-xs font-medium">{entry.label}</span>
                </div>
            ))}
        </div>
    );
}
